:host,
:host * {
  box-sizing: border-box;
}
:host {
  display: inline-flex;
  height: var(--aha-spinner--size);
  width: var(--aha-spinner--size);
  position: relative;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  vertical-align: super;
}
#track,
#spinner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: inherit;
  width: inherit;
  border-style: solid;
  border-radius: inherit;
}

@keyframes aha-spinner {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}
